// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__YgajN","selects":"Documents_selects__1PsWP"};